import { ILoggerOutput, LogLevel } from '@fe/core';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import feVersion from '../utils/version-helper';

export let appInsights: ApplicationInsights | null = null;

export function initInsights() {
    if (globalThis.env?.AZURE_AI_CS && !globalThis.env.AZURE_AI_CS.startsWith('__')) {
        const reactPlugin = new ReactPlugin();
        appInsights = new ApplicationInsights({
            config: {
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: {}
                },
                disableFetchTracking: false,
                disableAjaxTracking: false,
                enableUnhandledPromiseRejectionTracking: true,
                enableDebug: import.meta.env.DEV,
                connectionString: globalThis.env.AZURE_AI_CS,
                maxAjaxCallsPerView: -1
            }
        });

        appInsights.loadAppInsights();
        appInsights.context.application.ver = 'fe-web ' + feVersion.version;
        appInsights.context.application.build = feVersion.buildNumber.toString();
    }
}

export function getTraceId(): string | null {
    return appInsights?.context?.telemetryTrace?.traceID ?? null;
}

export class AzureApplicationInsightsLogger implements ILoggerOutput {
    log(level: LogLevel, args: any[]) {
        // Not used
    }

    exception(error: unknown, customProperties?: Record<string, any>) {
        if (!(error instanceof Error)) {
            return;
        }

        appInsights?.trackException({ exception: error }, customProperties);
    }
}
